import { NgModule } from '@angular/core';
import { LibAccountDetailsIconComponent } from './lib-account-details-icon.component';

@NgModule({
  declarations: [LibAccountDetailsIconComponent],
  imports: [],
  exports: [LibAccountDetailsIconComponent],
})
export class LibAccountDetailsIconModule {}
